var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.760254 17.1337H17.2397V0.866211H0.760254V17.1337ZM17.5458 18H0.453951C0.203563 18 0 17.7681 0 17.483V0.517222C0 0.231935 0.203563 0 0.453951 0H17.5458C17.7962 0 18 0.231688 18 0.517222V17.483C18 17.7678 17.7962 18 17.5458 18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6196 4.64553H0.617209C0.407143 4.64553 0.237183 4.45644 0.237183 4.22327C0.237183 3.98987 0.40736 3.80078 0.617209 3.80078H17.6196C17.8296 3.80078 17.9998 3.98987 17.9998 4.22327C17.9998 4.4562 17.8294 4.64553 17.6196 4.64553Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.12316H16V6H2V7.12316ZM2 11.2462H16V10.123H2V11.2462ZM2 15.3692H16V14.2461H2V15.3692Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.9b440de7f6d732acf5fcc4dce8c237cb.svg";
export { ForwardRef as ReactComponent };